// components/CancelConfirmationModal.jsx
import { XCircle, AlertTriangle } from "lucide-react";

export default function CancelConfirmationModal({ isOpen, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-75 transition-opacity duration-300 ease-in-out">
      <div className="bg-white rounded-xl   p-8 w-full max-w-sm transform scale-100 transition-transform duration-300 ease-in-out">
        <div className="flex items-center space-x-4 mb-4">
          <AlertTriangle size={24} className="text-yellow-500" />
          <h3 className="text-xl font-semibold text-gray-900">
            Confirm Cancellation
          </h3>
        </div>
        <p className="text-gray-600 mb-6">
          Are you sure you want to cancel the onboarding journey? This will clear all entered data.
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}